/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * service object
 * @export
 * @interface GetCorporationsCorporationIdStructuresService
 */
export interface GetCorporationsCorporationIdStructuresService {
    /**
     * name string
     * @type {string}
     * @memberof GetCorporationsCorporationIdStructuresService
     */
    name: string;
    /**
     * state string
     * @type {string}
     * @memberof GetCorporationsCorporationIdStructuresService
     */
    state: GetCorporationsCorporationIdStructuresServiceStateEnum;
}


/**
 * @export
 */
export const GetCorporationsCorporationIdStructuresServiceStateEnum = {
    Online: 'online',
    Offline: 'offline',
    Cleanup: 'cleanup'
} as const;
export type GetCorporationsCorporationIdStructuresServiceStateEnum = typeof GetCorporationsCorporationIdStructuresServiceStateEnum[keyof typeof GetCorporationsCorporationIdStructuresServiceStateEnum];


/**
 * Check if a given object implements the GetCorporationsCorporationIdStructuresService interface.
 */
export function instanceOfGetCorporationsCorporationIdStructuresService(value: object): value is GetCorporationsCorporationIdStructuresService {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('state' in value) || value['state'] === undefined) return false;
    return true;
}

export function GetCorporationsCorporationIdStructuresServiceFromJSON(json: any): GetCorporationsCorporationIdStructuresService {
    return GetCorporationsCorporationIdStructuresServiceFromJSONTyped(json, false);
}

export function GetCorporationsCorporationIdStructuresServiceFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCorporationsCorporationIdStructuresService {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'state': json['state'],
    };
}

export function GetCorporationsCorporationIdStructuresServiceToJSON(json: any): GetCorporationsCorporationIdStructuresService {
    return GetCorporationsCorporationIdStructuresServiceToJSONTyped(json, false);
}

export function GetCorporationsCorporationIdStructuresServiceToJSONTyped(value?: GetCorporationsCorporationIdStructuresService | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'state': value['state'],
    };
}

